<template>
  <div>
    <div
      v-if="userInfo && userInfo.user"
      class="sticky top-0 z-50 bg-white shadow-md"
    >
      <StudentHeader v-if="this.userInfo.user.permission == 'student'" />
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <div class="w-full">
      <div class="container mx-auto max-w-[1200px]">
        <div class="py-10 px-6" v-if="notificationIndex == null">
          <div
            class="font-bold text-2xl pb-6 flex items-center gap-3 text-slate-800"
          >
            Notifications
            <!-- <span
              class="bg-blues flex items-center justify-center text-white w-7 h-7 text-[10px] font-black rounded-full"
              v-if="total_count != 0"
            >
              {{ total_count }}
            </span> -->
             <span class=" text-sm font-normal text-gray-500"  v-if="total_count != 0">
                            ({{ total_count || 0 }})
                          </span>
          </div>

          <div class="flex flex-col gap-3">
            <div
              v-if="notificationList.length != 0"
              class="flex flex-col gap-3"
            >
              <div
                v-for="(notifi, index) in notificationList"
                :key="notifi.id"
                @click="setNotificationTab(index)"
              >
                <div
                  @click="notifyclick(notifi.id)"
                  class="relative flex justify-between border-2 transition-all duration-300 gap-4 py-4 px-6 rounded-2xl cursor-pointer"
                  :class="{
                    /* UNREAD: Vibrant, White, Blue border */
                    'bg-white border-blue-400 shadow-md ring-1 ring-blue-50 hover:bg-blue-50':
                      !notifi.read,
                    /* READ: Muted Slate, subtle border */
                    'bg-white border-slate-200 hover:bg-slate-50/80 hover:border-slate-300':
                      notifi.read,
                  }"
                >
                  <div class="flex items-center gap-4 w-full">
                    <div
                      class="p-2 rounded-xl transition-colors"
                      :class="
                        !notifi.read
                          ? 'bg-blue-50 text-blue-600'
                          : 'bg-slate-200 text-slate-400'
                      "
                    >
                      <img
                        v-if="notifi.read"
                        src="@/assets/newd/Vector(2).svg"
                        class="w-4 h-4 opacity-40 grayscale"
                        alt="read"
                      />
                      <img
                        v-else
                        src="@/assets/newd/Group(1).svg"
                        class="w-4 h-4"
                        alt="unread"
                      />
                    </div>
                    <div class="min-w-0 flex-1">
                      <div class="flex items-center gap-2">
                        <h3
                          class="text-sm truncate transition-colors duration-200"
                          :class="
                            !notifi.read
                              ? 'font-bold text-slate-900'
                              : 'font-semibold text-slate-700'
                          "
                        >
                          {{ notifi.course_title }}
                        </h3>
                        <!-- Unread Badge Dot -->
                        <!-- <span 
              v-if="!notifi.read" 
              class="inline-block h-2 w-2 rounded-full bg-blues shrink-0 animate-pulse"
            ></span> -->
                      </div>

                      <p
                        class="mt-1 text-xs leading-relaxed line-clamp-2"
                        :class="
                          !notifi.read
                            ? 'text-slate-700 font-medium'
                            : 'text-slate-500'
                        "
                      >
                        {{ notifi.topic }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="shrink-0 flex flex-col items-end gap-1 self-start sm:self-center"
                  >
                    <span
                      class="text-[11px] font-semibold tracking-tight whitespace-nowrap px-2.5 py-1 rounded-full transition-colors"
                      :class="[
                        !notifi.read
                          ? 'bg-blue-50 text-blue-700 border border-blue-100'
                          : 'bg-slate-50 text-slate-400 border border-slate-100',
                      ]"
                    >
                      {{
                        new Date(notifi.created_at).toLocaleDateString(
                          "en-IN",
                          { day: "2-digit", month: "short", year: "numeric" },
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="notificationList.length == 0"
              class="flex flex-col items-center py-20 border-2 border-dashed border-slate-200 rounded-3xl text-slate-400"
            >
              <p class="font-bold">No Notifications Yet</p>
            </div>
          </div>

          <div
            v-if="notificationList && notificationList.length > 0"
            class="flex justify-center py-8"
          >
            <Pagination
              ref="paginationRef"
              :totalPages="totalPages"
              @page-changed="loadMessages"
            />
          </div>
        </div>

        <div
          class="py-10 px-6 max-w-4xl mx-auto"
          v-if="notificationIndex != null"
        >
          <button
            @click="triggerPage()"
            class="group flex items-center gap-2 bg-slate-100 hover:bg-hover text-slate-600 hover:text-white text-xs font-bold px-5 py-2 rounded-full transition-all"
          >
            <svg
              class="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back
          </button>

          <div
            @click="handleNotification(selectNotificationData)"
            :class="[
              selectNotificationData?.course_id &&
              selectNotificationData?.department_id
                ? 'cursor-pointer hover:shadow-md hover:border-blue-300'
                : 'cursor-default',
            ]"
            class="mt-8 bg-white border border-slate-200 rounded-3xl p-8 shadow-sm"
          >
            <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
              <h2 class="font-bold text-2xl text-slate-900">
                {{ selectNotificationData.topic }}
              </h2>
              <span
                class="text-xs bg-blue-50 text-blue-600 px-4 py-1.5 rounded-full font-bold border border-blue-100"
              >
                {{
                  new Date(
                    selectNotificationData.created_at,
                  ).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                }}
              </span>
            </div>

            <div
              v-if="selectNotificationData.is_student_enrollment"
              class="space-y-1"
            >
              <p>Student Name : {{ parsedEnrollment?.student_name }}</p>
              <p>Student Email : {{ parsedEnrollment?.student_email }}</p>
              <p>Program : {{ parsedEnrollment?.program?.name }}</p>
              <p>Batch : {{ parsedEnrollment?.batch?.name }}</p>
              <p v-if="parsedEnrollment?.semester?.name">
                Semester : {{ parsedEnrollment.semester.name }}
              </p>
            </div>
            <div v-else>
              {{ selectNotificationData.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import StudentHeader from "@/components/Student/Header.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Notifications",

  components: {
    StudentHeader,
    Footer,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
  },

  data() {
    return {
      notificationIndex: null,
      selectNotificationData: "",
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
      notificationList: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo", "notificationData"]),
    parsedEnrollment() {
      if (!this.selectNotificationData?.message) return null;
      try {
        return JSON.parse(this.selectNotificationData.message);
      } catch (e) {
        console.error("Failed to parse notification message:", e);
        return null;
      }
    },
  },

  mounted() {
    this.$store.dispatch("connectWebSocket");
    this.$store.commit("SET_ON_NEW_NOTIFICATION", () => {
      this.loadMessages(this.currentPage, false);
    });
    this.loadMessages(this.currentPage, true);
  },

  methods: {
    handleNotification(notifi) {
      if (!notifi?.course_id || !notifi?.department_id) {
        return;
      }

      this.$router.push(
        `/course/dashboard/${notifi.course_id}/${notifi.department_id}/assignments`,
      );
    },
    async loadMessages(page = 1) {
      if (!this.userInfo) return;
      const data = await this.$store.dispatch("fetchNotificationList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.notificationList = data.data;
      console.log("test/////////////////000000", this.notificationList);
      this.currentPage = data.current_page;
      this.totalPages = data.total_page;
      this.total_count = data.total;
    },

    ...mapMutations(["notifyCount"]),

    triggerPage() {
      this.notificationIndex = null;
      this.$nextTick(() => {
        if (this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage);
        }
      });
    },

    setNotificationTab(index) {
      this.notificationIndex = index;
      this.selectNotificationData = this.notificationList[index];
    },

    notifyclick(id) {
      let formdata = {
        read: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/update-notification/${id}/?Key=${this.userInfo.token_key}`,
          formdata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.loadMessages(this.currentPage);
          }
        })
        .catch((error) => {
          console.error("Error updating notification:", error);
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}
</style>
